module.exports = __webpack_public_path__ + "img/10.7b2db2ad.jpg";